import { Box, Text, VStack } from '@elkaso-app/web-design';

export interface IFamilyDateCell {
  createdAt?: string;
  updatedAt?: string;
}

export const formatFamilyDate = (dateString?: string) => {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const FamilyDateCell = ({ createdAt, updatedAt }: IFamilyDateCell) => {
  return (
    <VStack align='start' spacing={2}>
      <Box>
        <Text fontSize='xs' color='gray.500' fontWeight='medium' mb={1}>
          Created
        </Text>
        <Text fontSize='sm' color='gray.700'>
          {formatFamilyDate(createdAt)}
        </Text>
      </Box>
      {createdAt !== updatedAt && (
        <Box>
          <Text fontSize='xs' color='gray.500' fontWeight='medium' mb={1}>
            Updated
          </Text>
          <Text fontSize='sm' color='blue.600'>
            {formatFamilyDate(updatedAt)}
          </Text>
        </Box>
      )}
    </VStack>
  );
};
